import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance.js';
import { Link } from "react-router-dom";
import {SideBar} from "../SideBar/SideBar.js";

import { FaArrowRight } from "react-icons/fa";

const ServicePagePanel = () => {
  const [backgroundImage, setBackgroundImage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [serviceBg, setServiceBg] = useState(null);
  const [loadingServices, setLoadingServices] = useState(false);
  const [errorServices, setErrorServices] = useState(null);
  const [services, setServices] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editService, setEditService] = useState({
    _id: '',
    title: '',
    image: null, 
    description: ''
  });

  useEffect(() => {
    fetchServiceBackground();
  }, []);

  const fetchServiceBackground = async () => {
    try {
      const response = await axiosInstance.get('/servicepage/bg');
      const fetchedServiceBg = response.data[0]; 
      setServiceBg(fetchedServiceBg);
      setBackgroundImage(fetchedServiceBg.BackgroundImage);
    } catch (error) {
      console.error('Failed to fetch service background:', error);
      setError('Failed to fetch service background');
    }
  };

  const handleBgChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setBackgroundImage(file);
    }
  };

  const handleUpload = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('BackgroundImage', backgroundImage);

      if (serviceBg) {
        await axiosInstance.put(`/servicepage/bg/${serviceBg._id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        alert('Service background updated successfully');
        
        fetchServiceBackground(); 
      } else {
        console.error('Service background is not defined.');
        setError('Service background is not defined.');
      }
    } catch (error) {
      console.error('Failed to update service background:', error);
      setError('Failed to update service background');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      setLoadingServices(true);
      const response = await axiosInstance.get('/singleservice/content');
      setServices(response.data);
    } catch (error) {
      console.error('Failed to fetch services:', error);
      setErrorServices('Failed to fetch services');
    } finally {
      setLoadingServices(false);
    }
  };

  const handleEdit = (service) => {
    setEditMode(true);
    setEditService({
      _id: service._id,
      title: service.title,
      image: null, 
      description: service.description
    });
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    setEditService({
      _id: '',
      title: '',
      image: null,
      description: ''
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEditService(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setEditService(prevState => ({
        ...prevState,
        image: file
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingServices(true);
    try {
      const formData = new FormData();
      formData.append('title', editService.title);
      formData.append('description', editService.description);
      
      // Append image if it's selected
      if (editService.image) {
        formData.append('image', editService.image);
      }

      const response = await axiosInstance.put(`/singleservice/${editService._id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const updatedServices = services.map(service =>
        service._id === editService._id ? response.data : service
      );
      setServices(updatedServices);
      alert('Service updated successfully');
      setEditMode(false);
    } catch (error) {
      console.error('Failed to update service:', error);
      setErrorServices('Failed to update service');
    } finally {
      setLoadingServices(false);
    }
  };
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
<div className="flex"> 
<SideBar />              
      <div className="flex-1 h-screen p-6 overflow-auto bg-gray-100">
      <div className="max-w-3xl mx-auto panel-container">
      <div className="panel-form bg-white p-8 rounded-lg shadow-xl">
      {error && <p>{error}</p>}
      <h2 className="admin-nav-heading text-2xl font-semibold mb-6 text-gray-800">Edit Service Background</h2>
      {loading ? (
        <p>Updating...</p>
      ) : (
        <div>
          <img src={backgroundImage} alt="Service Background" style={{ maxWidth: '100%' }} />
          <input type="file" onChange={handleBgChange} accept="image/*" />
          <button className="px-6 py-3 bg-red-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300" onClick={handleUpload}>Update Background</button>
        </div>
      )}
    </div>
    <div>
      <h2>Edit Services</h2>
      {loadingServices ? (
        <p>Loading...</p>
      ) : errorServices ? (
        <p>{errorServices}</p>
      ) : (
        <div>
          {!editMode && (
            <div>
              {services.map(service => (
                <div key={service._id}>
                  <h3>{service.title}</h3>
                  <img src={service.image} alt={service.title} style={{ maxWidth: '100px' }} />
                  <p>{service.description}</p>
                  <button className="px-6 py-3 bg-red-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300" onClick={() => handleEdit(service)}>Edit</button>
                </div>
              ))}
            </div>
          )}

          {editMode && (
            <form className="space-y-6" onSubmit={handleSubmit}>
              <label>Title:</label>
              <input
                type="text"
                name="title"
                value={editService.title}
                onChange={handleInputChange}
                required
              />
              <br />

              <label>Description:</label>
              <textarea
                name="description"
                value={editService.description}
                onChange={handleInputChange}
                required
              />
              <br />

              <label>Image:</label>
              <input
                type="file"
                onChange={handleFileChange}
                accept="image/*"
              />
              <br />

              <button type="submit">Update Service</button>
              <button type="button" onClick={handleCancelEdit}>Cancel</button>
            </form>
          )}
        </div>
      )}
    </div>
      </div>
    </div>
    </div>
  );
};

export default ServicePagePanel;
